import { render } from "./StackedBarChart.vue?vue&type=template&id=429dfe23&scoped=true"
import script from "./StackedBarChart.vue?vue&type=script&lang=js"
export * from "./StackedBarChart.vue?vue&type=script&lang=js"

import "./StackedBarChart.vue?vue&type=style&index=0&id=429dfe23&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-429dfe23"]])

export default __exports__